import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminProfitService } from '@/modules/profit/services/admin-profit.service'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'

@vservice()
export class AdminStoreProfitUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminProfitService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(data: ProfitRequest) {
    return this.service.storeProfit(data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
